import { gsap } from "gsap/all";
import { component } from "picoapp";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
const delegate = require("delegate");

import { str2json } from "@utils";
// import './component.scss';

class Modal {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.isActive = false;
    this.identifier = el.dataset.identifier;
    this.init(el);
    this.initAnimations();
    this.bindEvents();
  }

  init(el) {
    // cache elements
    this.el = el;
    this.modal = el;
    this.body = document.querySelector("body");
    this.pageWraper = document.querySelector(".Main");
    this.modalContent = el.querySelector(".Modal__content");
    this.modalBox = el.querySelector(".Modal__box");
    this.backdrop = el.querySelector(".backdrop");

    const defaults = {
      // position: 'left'
    };

    const instanceOptions = str2json(this.el.dataset.options);
    const options = { ...defaults, ...instanceOptions };
  }

  initAnimations() {
    const body = document.body;
    const wrapper = this.el;
    const backdrop = this.backdrop;
    const modal = this.modalBox;

    this.tl = gsap.timeline({
      onStart: () => {
        gsap.set(wrapper, { display: "flex" });
        body.classList.add("has-modalOpen");
      },
      paused: true,
      onComplete: () => {
        this.isActive = true;
        disableBodyScroll(this.modalContent);
      },
      onReverseComplete: () => {
        this.isActive = false;
        body.classList.remove("has-modalOpen");
        enableBodyScroll(this.modalContent);
        gsap.set(wrapper, { display: "none" });
      },
    });

    this.tl.set(wrapper, { display: "flex", immediateRender: false });

    // Shade
    this.tl.fromTo(wrapper, { opacity: 0 }, { duration: 0.4, opacity: 1 });
    this.tl.fromTo(backdrop, { opacity: 0 }, { duration: 0.35, opacity: 1 });

    this.tl.fromTo(
      modal,
      {
        y: "50%",
        opacity: 0,
      },
      {
        y: "0%",
        opacity: 1,
        duration: 0.5,
        ease: "Expo.easeOut",
      },
      "-=0.4"
    );
  }

  bindEvents() {
    console.log("ctx:", this.ctx.getState());
    this.ctx.on("Modal", (state) => {
      console.log("stateHere", state);
      if (state.identifier === this.identifier) {
        this[state.action]();
      }
    });

    if (this.backdrop) {
      this.backdrop.addEventListener("click", (e) => {
        this.close();
      });
    }

    delegate(
      this.el,
      ".closeModal",
      "click",
      (e) => {
        this.close();
      },
      false
    );
  }

  toggle() {
    // Bailout if toggle component is disabled
    if (this.disabled) {
      return;
    }
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    const isActive = new CustomEvent("isActive");
    if (this.isActive) {
      return;
    }
    this.tl.play();
    this.el.dispatchEvent(isActive);
  }

  close() {
    const isInactive = new CustomEvent("isInactive");
    if (!this.isActive) {
      return;
    }
    this.tl.reverse();
    this.el.dispatchEvent(isInactive);
  }
}

export default component((node, ctx) => {
  new Modal(node, ctx);
});
